import { ArrowRight, Star, Truck, ShieldCheck, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";

const HERO_IMG = "https://customer-assets-agu9un31.emergentagent.net/job_cat-cage-shop/artifacts/aamtpp3b_IMG_1930.jpeg";
const ABOUT_IMG = "https://customer-assets-agu9un31.emergentagent.net/job_cat-cage-shop/artifacts/aamtpp3b_IMG_1930.jpeg";

const Home = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data.slice(0, 4))).catch(() => {});
  }, []);

  return (
    <div data-testid="home-page">
      {/* HERO */}
      <section className="relative overflow-hidden">
        {/* Mobile background image (behind text) */}
        <div className="lg:hidden absolute inset-0 z-0 bg-[#1C1C1C]" aria-hidden="true">
          <img
            src={HERO_IMG}
            alt=""
            className="w-full h-full object-contain object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#1C1C1C]/60 via-[#1C1C1C]/50 to-[#1C1C1C]/85" />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 pt-12 lg:pt-20 pb-16 lg:pb-24">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
            <div className="lg:col-span-7">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/15 lg:bg-[#F4F1EA] border border-white/25 lg:border-[rgba(28,28,28,0.08)] backdrop-blur-sm lg:backdrop-blur-0">
                <Sparkles className="w-3.5 h-3.5 text-[#E07A5F]" />
                <span className="label-eyebrow text-white lg:text-[#1C1C1C]">Pilihan #1 di Malaysia</span>
              </div>

              <h1 className="font-heading font-bold text-5xl sm:text-6xl lg:text-7xl tracking-tight text-white lg:text-[#1C1C1C] mt-6 leading-[1.02] text-balance">
                Rumah selesa untuk{" "}
                <span className="italic font-medium text-[#E07A5F]">kucing</span> kesayangan anda.
              </h1>

              <p className="text-base lg:text-lg text-white/85 lg:text-[#4A4A4A] mt-6 max-w-xl leading-relaxed">
                Sangkar Murah Enterprise membekalkan sangkar kucing custom-made
                berkualiti tinggi. Setiap unit dibuat khas mengikut saiz dan
                keperluan kucing kesayangan anda — tahan lasak, mudah dibersihkan,
                dan dihantar ke seluruh Malaysia.
              </p>

              <div className="flex flex-wrap items-center gap-3 mt-9">
                <Link
                  to="/katalog"
                  data-testid="hero-shop-btn"
                  className="group inline-flex items-center gap-2 pl-4 pr-7 py-3 rounded-xl bg-[#1C1C1C] text-[#FAF9F6] hover:bg-[#E07A5F] transition-all duration-300 font-semibold text-sm"
                >
                  <img
                    src="https://customer-assets-agu9un31.emergentagent.net/job_cat-cage-shop/artifacts/dnl2n71o_IMG_3412.png"
                    alt=""
                    className="w-8 h-8 object-contain"
                  />
                  Lihat Katalog Sangkar
                  <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </Link>
                <Link
                  to="/tentang"
                  data-testid="hero-learn-btn"
                  className="inline-flex items-center gap-2 px-7 py-4 rounded-xl border border-white/40 lg:border-[rgba(28,28,28,0.15)] text-white lg:text-[#1C1C1C] hover:border-white lg:hover:border-[#1C1C1C] transition-all duration-300 font-semibold text-sm"
                >
                  Kenapa Pilih Kami
                </Link>
              </div>

              <div className="mt-12 flex items-center gap-8">
                <div>
                  <div className="flex items-center gap-1">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} className="w-4 h-4 fill-[#E07A5F] text-[#E07A5F]" />
                    ))}
                  </div>
                  <p className="text-xs text-white/70 lg:text-[#4A4A4A] mt-1.5">4.9 dari 2,400+ pelanggan</p>
                </div>
                <div className="w-px h-12 bg-white/25 lg:bg-[rgba(28,28,28,0.1)]"></div>
                <div>
                  <div className="font-heading font-bold text-2xl text-white lg:text-[#1C1C1C]">7+ tahun</div>
                  <p className="text-xs text-white/70 lg:text-[#4A4A4A]">Pengalaman industri pet</p>
                </div>
              </div>
            </div>

            {/* Desktop-only image column */}
            <div className="hidden lg:block lg:col-span-5 relative">
              <div className="relative aspect-[4/5] rounded-[2.5rem] overflow-hidden bg-[#F4F1EA]">
                <img
                  src={HERO_IMG}
                  alt="Pelanggan Sangkar Murah Enterprise"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Trust strip */}
        <div className="border-y border-[rgba(28,28,28,0.08)] bg-[#F4F1EA]/50">
          <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-5 grid grid-cols-2 sm:grid-cols-4 gap-6 text-center sm:text-left">
            {[
              { icon: ShieldCheck, label: "Jaminan 1 Tahun" },
              { icon: Truck, label: "Penghantaran lori kedai" },
              { icon: Star, label: "4.9 Rating Pelanggan" },
              { icon: Sparkles, label: "Bahan Premium" },
            ].map((t, i) => (
              <div key={i} className="flex items-center justify-center sm:justify-start gap-3">
                <t.icon className="w-4 h-4 text-[#E07A5F]" />
                <span className="text-xs sm:text-sm font-semibold text-[#1C1C1C]">{t.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* WHY US */}
      <section className="bg-[#F4F1EA] py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            <div className="lg:col-span-5 relative">
              <div className="aspect-square rounded-[2.5rem] overflow-hidden bg-white">
                <img src={ABOUT_IMG} alt="Kucing comel" className="w-full h-full object-cover" />
              </div>
              <div className="absolute -top-6 -right-6 sm:-right-10 bg-[#1C1C1C] text-[#F4F1EA] rounded-2xl p-5 max-w-[220px]">
                <div className="font-heading font-bold text-3xl text-[#E07A5F]">2,400+</div>
                <p className="text-xs text-[#F4F1EA]/70 mt-1">Pelanggan gembira di Malaysia</p>
              </div>
            </div>

            <div className="lg:col-span-7">
              <div className="label-eyebrow text-[#E07A5F]">Kenapa Pilih Kami</div>
              <h2 className="font-heading font-bold text-4xl sm:text-5xl tracking-tight text-[#1C1C1C] mt-3 text-balance">
                Kualiti yang anda boleh harap, harga yang anda boleh bayar.
              </h2>
              <p className="text-base text-[#4A4A4A] mt-5 leading-relaxed max-w-xl">
                Kami percaya setiap kucing layak mendapat rumah yang selesa.
                Itulah sebabnya kami memilih dengan teliti setiap sangkar yang kami jual.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-10">
                {[
                  { title: "Bahan Tahan Lasak", desc: "Keluli bersalut anti-karat & kayu pilihan." },
                  { title: "Harga Borong", desc: "Beli terus dari pengilang, harga lebih berbaloi." },
                  { title: "Khidmat Pelanggan", desc: "Sokongan WhatsApp setiap hari 9am–9pm." },
                  { title: "Bayaran Selamat", desc: "Pindahan bank atau Cash on Delivery." },
                ].map((f, i) => (
                  <div key={i} className="p-5 bg-white rounded-2xl border border-[rgba(28,28,28,0.06)]">
                    <div className="w-9 h-9 rounded-lg bg-[#E07A5F]/10 text-[#E07A5F] flex items-center justify-center font-heading font-bold text-sm">
                      {String(i + 1).padStart(2, "0")}
                    </div>
                    <h3 className="font-heading font-semibold text-lg text-[#1C1C1C] mt-4">{f.title}</h3>
                    <p className="text-sm text-[#4A4A4A] mt-1.5 leading-relaxed">{f.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TESTIMONIAL */}
      <section className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-20 lg:py-28">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="label-eyebrow text-[#E07A5F]">Apa Kata Pelanggan</div>
          <h2 className="font-heading font-bold text-4xl sm:text-5xl tracking-tight text-[#1C1C1C] mt-3 text-balance">
            Dipercayai oleh ribuan pemilik kucing.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {[
            { name: "Aisyah R.", city: "Shah Alam", text: "Sangkar 3 tingkat saya beli untuk 3 ekor kucing. Sangat kukuh dan cantik. Penghantaran cepat!" },
            { name: "Faizal A.", city: "Johor Bahru", text: "Beli untuk pet shop saya. Quality memang setanding dengan harga yang lebih mahal di pasaran." },
            { name: "Nurul H.", city: "Kuala Lumpur", text: "Customer service sangat membantu masa pilih sangkar yang sesuai untuk anak kucing saya." },
          ].map((t, i) => (
            <div key={i} className="bg-white rounded-2xl p-8 border border-[rgba(28,28,28,0.08)]">
              <div className="flex items-center gap-1">
                {[...Array(5)].map((_, j) => (
                  <Star key={j} className="w-4 h-4 fill-[#E07A5F] text-[#E07A5F]" />
                ))}
              </div>
              <p className="text-base text-[#1C1C1C] mt-5 leading-relaxed">&ldquo;{t.text}&rdquo;</p>
              <div className="mt-6 pt-5 border-t border-[rgba(28,28,28,0.08)]">
                <div className="font-heading font-semibold text-[#1C1C1C]">{t.name}</div>
                <div className="text-xs text-[#4A4A4A] mt-0.5">{t.city}</div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 pb-20 lg:pb-28">
        <div className="bg-[#1C1C1C] rounded-[2.5rem] p-10 sm:p-14 lg:p-20 relative overflow-hidden">
          <div className="absolute inset-0 opacity-10" style={{ backgroundImage: "radial-gradient(#E07A5F 1px, transparent 1px)", backgroundSize: "24px 24px" }}></div>
          <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
            <div className="lg:col-span-8">
              <div className="label-eyebrow text-[#E07A5F]">Sedia untuk membeli?</div>
              <h2 className="font-heading font-bold text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#FAF9F6] mt-4 leading-[1.05] text-balance">
                Berikan kucing anda rumah yang dia layak terima.
              </h2>
            </div>
            <div className="lg:col-span-4 lg:text-right">
              <Link
                to="/katalog"
                data-testid="cta-shop-btn"
                className="group inline-flex items-center gap-2 px-8 py-4 rounded-xl bg-[#E07A5F] text-[#FAF9F6] hover:bg-[#D0674D] transition-all font-semibold"
              >
                Mula Membeli-belah
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
